module.exports = __webpack_public_path__ + "img/red-lucky-btn.1e2c8bf0.png";